import { render, staticRenderFns } from "./RegionSelector.vue?vue&type=template&id=768cf5b4&scoped=true&"
import script from "./RegionSelector.vue?vue&type=script&lang=js&"
export * from "./RegionSelector.vue?vue&type=script&lang=js&"
import style0 from "./RegionSelector.vue?vue&type=style&index=0&id=768cf5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768cf5b4",
  null
  
)

export default component.exports